import { NotificationCenter } from '@/components/notifications'

export function NotificationButton() {
  return (
    <NotificationCenter className="transition-tonal h-8 w-8 rounded-lg duration-200 hover:bg-muted/50" />
  )
}
